import { gql } from 'apollo-angular';

export const CHARGE = gql`
  query Charge($isTnCAccepted: Boolean!, $paymentRequest: PaymentRequestInput) {
    Charge(isTnCAccepted: $isTnCAccepted, paymentRequest: $paymentRequest) {
      amount
      capture_method
      clientSecret
      intentId
      isAdditionalActionRequired
      status
      transactionId
      razorpayOrderId
      message
    }
  }
`;

export const MOCK_CHARGE = gql`
  query MockPayment($type: String) {
    MockPayment(type: $type) {
      amount
      capture_method
      clientSecret
      intentId
      isAdditionalActionRequired
      status
      transactionId
      razorpayOrderId
      message
    }
  }
`;
export const GET_PAYMENT_METHOD = gql`
  query GetPaymentMethods($customerId: String, $businessId: String) {
    GetPaymentMethods(customerId: $customerId, businessId: $businessId) {
      name
      brand
      cardId
      expYear
      expMonth
      last4digit
    }
  }
`;

export const SAVE_CARD = gql`
  mutation CreatePaymentCustomer(
    $paymentMethodId: String
    $customer: CustomerInput!
    $businessId: String
  ) {
    CreatePaymentCustomer(
      paymentMethodId: $paymentMethodId
      customer: $customer
      businessId: $businessId
    )
  }
`;

export const DELETE_CARDS = gql`
  mutation DeletePaymentMethod($paymentMethodId: String, $businessId: String) {
    DeletePaymentMethod(
      paymentMethodId: $paymentMethodId
      businessId: $businessId
    )
  }
`;

export const GET_RAZORPAY_ORDER_ID = gql`
	mutation createRazorpayOrderId(
		$razorpayPaymentRequest: RazorpayPaymentRequestInput
	) {
		CreateRazorpayOrderId(razorpayPaymentRequest: $razorpayPaymentRequest) {
			id
			status
			created_at
		}
	}
	# query createRazorpayOrderId($simpayxOrderId: String) {
	# 	CreateRazorpayOrderId(simpayxOrderId: $simpayxOrderId) {
	# 		id
	# 		status
	# 		created_at
	# 	}
	# }
`;

export const VERIFY_PAYMENT_SIGNATURE = gql`
	query verifyPaymentSignature(
		$verifyPaymentSignature: RazorpayPaymentResponseInput,
		$businessId: String
	) {
		VerifyPaymentSignature(verifyPaymentSignature: $verifyPaymentSignature, businessId: $businessId) {
			isPaymentAuthorised
			message
		}
	}
`;

